import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";
import {
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Toolbar,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { MdLink } from "react-icons/md";
import { useEffect, useRef, useState } from "react";

import { IoMdAdd } from "react-icons/io";
import { MdOutlineDelete } from "react-icons/md";

import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import produce from "immer";

import Admin from "../../components/auth/Admin";
import Subscription from "../../actions/Subscription";
import Popup from "../../components/customHelpers/Popup";
import AddSubscription from "../../components/forms/addSubscription";
import AddOrganizationSubscription from "../../components/forms/addOrganizationSubscriptionService";
import Controls from "../../components/controls/Controls";

const headCells = [
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const SubscriptionPage = () => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const [openPopupAssign, setOpenPopupAssign] = useState(false);
  const [id, setId] = useState(null);
  const history = useHistory();
  const { viewAllSubscriptions, updateAdmin, deleteSubscription } = Subscription();

  const [subscriptions, setSubscriptions] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllSubscriptions();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllSubscriptions = () => {
    setValues({ ...values, loading: true });
    viewAllSubscriptions().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.subscriptionService) {
        setValues({
          ...values,
          loading: false,
        });
        setSubscriptions(data.subscriptionService);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(subscriptions, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["name"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteSubscription(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setSubscriptions(
          produce(subscriptions, (draft) => {
            const index = subscriptions.findIndex((staff) => staff.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Subscriptions
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Add"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
                setEdit(false);
              }}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{item.description}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Attach"
                                onClick={() => {
                                  setOpenPopupAssign(true);
                                  setId(item.id);
                                  setEdit(false);
                                  setRecordForEdit(null);
                                }}
                              >
                                <MdLink fontSize="medium" />{" "}
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Organizations"
                                onClick={() => {
                                  history.push(
                                    `/admin/organization-subscriptions/${item.id}`
                                  );
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              {!item?.organizationSubscriptions?.length > 0 && (
                                <Controls.ActionButton
                                  title="Delete"
                                  color="secondary"
                                  onClick={() => {
                                    setConfirmDialog({
                                      isOpen: true,
                                      title:
                                        "Are you sure to delete this record?",
                                      subTitle: "You can't undo this operation",
                                      onConfirm: () => {
                                        onDelete(item.id);
                                      },
                                    });
                                  }}
                                >
                                  <MdOutlineDelete />
                                </Controls.ActionButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Subscription Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddSubscription
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            edite={edite}
            getSubscription={getAllSubscriptions}
          />
        </Popup>
        <Popup
          title="Attach Organization Subscription"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <AddOrganizationSubscription
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            getSubscription={getAllSubscriptions}
            edite={edite}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default SubscriptionPage;
